import React, {useEffect} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

import {renderWidget} from './widgets'
import type {WidgetConfig} from './widgets/types'

export type OrderFormState = Record<string, unknown>

export type OrderFormProps = {
  /**
   * Дефолтное состояние формы
   */
  defaultValues?: OrderFormState
  /**
   * Блокирование возможности отправить форму
   */
  disableSubmit?: boolean
  /**
   * Любая загрузка формы
   */
  fetching?: boolean
  /**
   * Корневой виджет формы
   */
  layout?: WidgetConfig
  /**
   * Первая загрузка формы
   */
  loading?: boolean
  /**
   * Изменение любого поля формы
   * @param data Состояние формы
   * @returns void
   */
  onChange?: (data: OrderFormState) => void
}

export const OrderForm = ({defaultValues, layout, loading, onChange}: OrderFormProps): React.ReactElement => {
  const form = useForm({defaultValues})

  useEffect(() => {
    const subscription = form.watch(data => {
      onChange?.(data)
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [form, onChange])

  if (loading) {
    // TODO: Сверстать лоадер со скелетонами для первого фетча
    return <div>Loading...</div>
  }

  if (!layout) {
    throw new Error('Отсутствует корневой виджет формы')
  }

  return <FormProvider {...form}>{renderWidget(layout)}</FormProvider>
}
